const MinusIcon = () => {
    return (  
        <div className="size-6">
            <img src="images/minus-sign.svg" alt="" className="w-full h-full"/>
        </div>
    );
}
 
export default MinusIcon;